<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-clipboard" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">M&amp;E Checklist</h4>
              <small style="opacity: 0.8;">Complete the monitoring and evaluation form</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Checklist table -->
          <div v-show="showlist" class="card shadow-sm table-card mb-4">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-list" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">Checklist Items</h6>
              <span v-if="qas && qas.length" class="badge badge-light ml-auto" style="border-radius:20px;">
                {{ qas.length }} items
              </span>
            </div>

            <div class="card-body px-4 py-3">
              <form @submit.prevent="showPreview">
                <div class="table-responsive">
                  <table class="table align-td-middle mb-0">
                    <thead style="background: #f8fafc;">
                      <tr>
                        <th class="table-th" style="width: 25%;">Category</th>
                        <th class="table-th">Item / Question</th>
                        <th class="table-th" style="width: 30%;">Response</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in qas" :key="item.id" class="table-row">
                        <td class="px-4 py-3">
                          <span v-if="item.category" class="badge badge-soft-info" style="border-radius:20px;">
                            {{ item.category.category_name }}
                          </span>
                        </td>
                        <td class="py-3" style="font-size: 0.86rem;">{{ item.item_name }}</td>
                        <td class="py-3">
                          <div v-if="item.options && item.options.length >= 1 && item.is_multi_select">
                            <v-select v-model="item.option_select" :options="item.options"
                              label="option_name" :reduce="o => o.option_name"
                              multiple placeholder="Select one or more…" />
                          </div>
                          <select v-else-if="item.options && item.options.length >= 1"
                            required class="form-control form-control-sm" v-model="item.option_select">
                            <option value="" disabled>Select…</option>
                            <option :value="option.option_name"
                              v-for="option in item.options" :key="option.id">
                              {{ option.option_name }}
                            </option>
                          </select>
                          <input v-else required :type="item.response_type || 'text'"
                            class="form-control form-control-sm"
                            v-model="item.option_select" placeholder="Type response…" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4 d-flex justify-content-end">
                  <button type="submit" class="btn btn-submit px-5">
                    <i class="fe fe-eye mr-1"></i> Preview &amp; Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Preview component -->
          <PreviewMandE v-show="preview" :qas="qas" @clicked="onClickChild" />

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import PreviewMandE from "@/views/others/PreviewMandE.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Navbar, Loading, PreviewMandE },
  data() {
    return {
      showlist: true,
      preview: false,
      form_array: "",
      user: null,
      option_select: "",
      number: "",
      qas: "",
      edit: false,
      isLoading: false,
      fullPage: true,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    showPreview() {
      this.showlist = false;
      this.preview = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onClickChild() {
      this.showlist = true;
      this.preview = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getQA() {
      this.axios
        .get(`/api/v1/auth/quality-assurances/${this.$route.params.id}`)
        .then((response) => {
          this.getAllQas(response.data.data);
        })
        .catch((error) => { console.error(error); });
    },
    getAllQas(query) {
      this.axios
        .post(`/api/v1/auth/qa-getQaItems`, {
          agency_id: 407465,
          form_id: query.form_id,
          order_by: 'item_order',
        })
        .then((response) => {
          this.qas = response.data;
        })
        .catch((error) => { console.error(error); });
    },
    clearIt() {
      this.option_select = "";
      this.number = "";
    },
  },
  created() {
    this.getQA();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}

.header-icon-wrap {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.table-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }

.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}

.section-number {
  width: 28px; height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; flex-shrink: 0;
}

.table-th {
  font-size: 0.73rem; text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b; font-weight: 600;
  border-bottom: 2px solid #e2e8f0; padding: 12px 16px;
}

.table-row:hover { background: #f8fafc; }

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none; color: #fff;
  border-radius: 8px; font-weight: 600; padding: 8px 24px;
}

.btn-submit:hover { opacity: 0.9; color: #fff; }

.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}
</style>
